import axios from 'axios'

const API_PATH = 'api/v2/admins/scrapers/products'

const ScraperProductsApiV2 = {
  /**
   * Get list of `Scraper::Product` and its associations
   * Invoke from `GET api/v2/admins/scrapers/products`
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({
    //set default parameters
    id = '',
    page = 1,
    perPage = 10,
    gender = '',
    originSku = '',
    brand = '',
    category = '',
    curationStatus = '',
    brandClassification = '',
    availableOnSource = '',
    website = ''
  }) => {
    const params   = {
      id                   : id,
      page                 : page,
      per_page             : perPage,
      category             : category,
      original_sku         : originSku,
      curation_status      : curationStatus,
      available_on_source  : availableOnSource,
      brand_classification : brandClassification,
      website              : website,
      gender               : gender,
      brand                : brand
    }
    const path     = API_PATH
    const response = await axios.get(path, { params })
    return response
  },

  /**
   * Get the details of a single `Scraper::Product`
   * Invoke from `GET api/v2/admins/scrapers/products/:id`
   * @param {number} id - ID of Scraper Product
   */
  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = await axios.get(path)
    return response
  },

  /**
   * Reject `Scraper::Product` in Curation Process
   * Invoke from `PATCH api/v2/admins/scrapers/products/:id/rejects`
   * @param {number} id - ID of Scraper Product
   */
  reject: async (id) => {
    const path     = `${API_PATH}/${id}/rejects`
    const response = await axios.patch(path)
    return response
  },

  /**
   * Accepy `Scraper::Product` in Curation Process
   * Invoke from `POST api/v2/admins/scrapers/products/:id/accepts`
   * @param {number} id - ID of Scraper Product
   * @param {object} attributes - attributes of Scraper Product
   */
  accept: async (id, payload) => {
    const path     = `${API_PATH}/${id}/accepts`
    const response = await axios.post(path, payload)
    return response
  },

  /**
   * Get one `Merchant`
   * @param {object} id merchant id
   * @return {object} `Merchant`
   */
  update_customer_order_status: async (id, orderStatus) => {
    const path     = `${API_PATH}/${id}/update_customer_order_status`
    const body     = {
      order_status: orderStatus
    }
    const response = axios.patch(path, body)
    return response
  },
  /**
   * Create a scraper product
   * @param {object} params - parameters required for Creating Scraper Product
   * @return {object} attributes - attributes of Scraper Product
   */
  create: async (params) => {
    const path     = `${API_PATH}/`
    const response = await axios.post(path, params)
    return response
  },
  /**
   * Change status of a productable scraper product
   * @param {number} scraperProductId - Productable Id
   * @param {string} newStatus - new Status for Product
   * @return {object} attributes - attributes of Scraper Product
   */
  changeStatus: (scraperProductId, newStatus) => {
    const params = {
      status: newStatus
    }

    const path     = `${API_PATH}/${scraperProductId}/status`
    const response =  axios.patch(path, params)
    return response
  },
  /**
   * Change status of a productable scraper product
   * @param {number} scraperProductId - Productable Id
   * @param {object} values - params required for updating price
   * @return {object} attributes - attributes of Scraper Product
   */
  updatePrice: (values) => {
    const params   = {
      selling_price: values.selling_price
    }
    const path     = `${API_PATH}/${values.scraperProductId}/price`
    const response =  axios.patch(path, params)
    return response
  }
}

export default ScraperProductsApiV2
